export default __webpack_public_path__ + "static/media/sn21.23b3c8b8.jpg";